<p *ngFor="let message of lineMessages">{{ message || "&nbsp;" }}</p>
